/** Bounds for stored terminal chat settings, applied by the daemon and the CLI and offered by the web.
 * Prompt history rewrites stay bounded. */
export const PROMPT_HISTORY_DEPTH_BOUNDS: [min: number, max: number] = [20, 1000];
